import React, { Component } from "react";
import { Card, Grid, Button } from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { withRouter } from "react-router-dom";
import { forgotPassword } from "../../services/user";
import { withToastManager } from "react-toast-notifications";

class ForgotPassword extends Component {
  state = {
    email: "",
  };

  handleChange = (event) => {
    event.persist();
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleForgotPassword = async () => {
    const { email } = this.state;
    const { toastManager } = this.props;

    forgotPassword(email)
      .then((res) => {
        if (res.data.success || res.data.message) {
          toastManager.add(res.data.message, {
            appearance: "success",
            autoDismiss: true,
          });
          this.setState({
            email: "",
          });
        }
      })
      .catch((err) => {
        let message;
        if (err.response) {
          message = err.response.data.message;
        } else {
          message = err.message;
        }

        toastManager.add(message, {
          appearance: "error",
          autoDismiss: true,
        });
      });
  };

  render() {
    let { email } = this.state;

    return (
      <div className="signup flex justify-center w-full h-full-screen">
        <div className="p-8">
          <Card className="forget-card position-relative y-center">
            <Grid container>
              <Grid item lg={5} md={5} sm={5} xs={12}>
                <div className="p-8 flex justify-center items-center h-full">
                  <img src="/assets/images/eazydiner_1.jpg" alt="" />
                </div>
              </Grid>
              <Grid item lg={7} md={7} sm={7} xs={12}>
                <div className="p-9 h-full bg-light-gray position-relative">
                  <ValidatorForm
                    ref="form"
                    onSubmit={this.handleForgotPassword}
                  >
                    <TextValidator
                      className="mb-6 w-full"
                      variant="outlined"
                      label="Email"
                      onChange={this.handleChange}
                      type="email"
                      name="email"
                      value={email}
                      validators={["required", "isEmail"]}
                      errorMessages={["*Field required", "*Email is not valid"]}
                    />
                    <div className="flex items-center">
                      <Button variant="contained" color="primary" type="submit">
                        Reset Password
                      </Button>

                      <span className="ml-4 mr-2">or</span>
                      <Button
                        className="capitalize"
                        onClick={() =>
                          this.props.history.push("/session/signin")
                        }
                      >
                        Sign in
                      </Button>
                    </div>
                  </ValidatorForm>
                </div>
              </Grid>
            </Grid>
          </Card>
        </div>
      </div>
    );
  }
}

export default withRouter(withToastManager(ForgotPassword));
